<template>
  <div class="add-to-cart">
    Order
    <b-form-input
        id="qty"
        type="number"
        ref="qty"
        v-model="quantity"
        value="qtysuggested"
        :min="leadProduct.qtymin"
        :max="leadProduct.qtymax"
        :step="leadProduct.qtystep"
    ></b-form-input>
    <!-- of this {{ leadProduct.singular }} at -->
    at
    $<span id="visible-price" class="product-price">{{ leadProduct.price.toFixed(2) }}</span>
    each.
    <div class="blockcenter small">
      Minimum order: {{ leadProduct.qtymin }}. Available in multiples of: {{ leadProduct.qtystep }}.
    </div>
    <b-button
        variant="primary"
        class="mt-2"
        v-b-modal.modal-confirm
        :disabled="!this.leadDesign.image.key"
        size="">
      <!-- <b-icon-x-circle aria-hidden="true"></b-icon-x-circle> -->
      Review and Add to Cart
    </b-button>
    <div class="notice" v-if="leadProduct.notice">
      {{ leadProduct.notice }}
    </div>

    <b-modal
        id="modal-confirm"
        title="Confirm Design"
        v-model="showModal"
        @ok="addToCart"
        ok-only
        ok-variant="secondary">
      <div class="preview">
        <div v-for="product in products" :key="product.id"
            class="thumb"
            :style="{ width: product.realsize, 'max-width': thumbMaxWidth }">
          <DesignView
              :design="designs[product.key]"
              :toolimages="product.toolimages"
              ref="preview"
          ></DesignView>
        </div>
        <span id="review-quantity">x {{ quantity }}</span>
        <div id="review-name">
          <b-form-input id="name" v-model="leadDesign.name" placeholder="Untitled design">
          </b-form-input>
          <label for="name" class="">Name</label>

        </div>
      </div>

      <div class="confirmtext" v-html="leadProduct.confirmtext"></div>

      <div class="addtocart center pb-3">
        <b-button @click.prevent.stop="saveAndAdd" variant="primary">Add to Cart</b-button>
      </div>

      <p class="small">
        <strong>Please note:</strong>
        BottleMark cannot guarantee exact reproduction of on-screen colors.
        Printed materials may vary slightly in position.
        For caps, the base caps may have small imperfections and some shipping damage is common.
        Label print accuracy is subject to variation;
        we only guarantee portions within the safe zone will appear within the cut.
      </p>

      <p class="small">
        By ordering, you agree that you have the right to reproduce this image
        and grant BottleMark the legal permission to print your design;
        you also agree to indemnify and hold harmless BottleMark LLC for any violation of
        copyright, trademark, or other law arising from printing this image.
        You retain copyright to your work, and we promise not to use your design
        for any other purpose without your express permission.
      </p>

      <template v-slot:modal-ok>
        Cancel
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

// import { BIconPlusCircle, BIconXCircle } from 'bootstrap-vue';
import axios from 'axios';

import DesignView from '@/components/DesignView.vue';
import { designSavePayload, getCircularReplacer } from '@/utils';

export default {
  name: 'AddToCart',
  components: {
    DesignView,
    // BIconPlusCircle,
    // BIconXCircle,
  },
  props: {
    // msg: String,
    qtysuggested: Number,
  },
  data() {
    return {
      showModal: false,
      quantity: this.qtysuggested,
    };
  },
  computed: {
    numProducts() {
      return Object.keys(this.products).length;
    },
    thumbMaxWidth() {
      return String(75 / this.numProducts) + '%'; // eslint-disable-line prefer-template
    },
    ...mapState(['products', 'designs', 'config']),
    ...mapGetters(['leadProduct', 'leadDesign']),
  },
  methods: {
    // confirm() {
    //   console.log('confirm', this.quantity);
    //   // this.$store.commit('toggleGuide');
    // },
    saveAndAdd() {
      // on click, we save a read-only version before adding to cart.
      console.log('addClick');
      // const params = designSavePayload(this.leadDesign, this.product, true);
      // create a pair of read-only save params
      const params = [];
      Object.entries(this.designs).forEach(([key, design]) => {
        if (design.image.key) {
          params.push(designSavePayload(design, this.products[key], true));
        }
      });

      console.log('saveAndAdd payload:', params);

      axios.post(this.config.designSaveURL, params)
        .then((response) => {
          // console.log('saveAndAdd: response data', response.data);
          const { id, name } = response.data[0];
          console.log('saveAndAdd: saved. designcode:', id, 'name:', name);
          const roDesigncode = id;
          // this.design.name = name;
          this.addToCart(roDesigncode);
        })
        .catch((error) => {
          console.log(error);
          let errmsg = 'An unknown error occurred.';
          if (error.request) {
            console.log(error.request);
            errmsg = `An error occurred: ${error.response.statusText} (${error.response.status})`;
          } else if (error.response) {
            console.log(error.response);
            errmsg = 'Could not contact the server.';
          } else {
            console.log(error.message);

            // try to report a (safed) version of what happened to the server
            const errParams = JSON.stringify(params, getCircularReplacer());
            axios.post(
              this.config.logURL,
              {
                location: 'AddToCart.vue',
                message: error.message,
                params: errParams,
                error: error.toJSON(),
              },
            ); // no .then/.error as we don't care what happens

            errmsg = `An unexpected error occurred. Please contact info@bottlemark.com: ${error.message}.`;
          }
          this.$bvToast.toast(
            errmsg,
            {
              title: 'Save Error',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 12000,
              variant: 'danger',
              solid: true,
            },
          );
        });
    },
    addToCart(readonlyDesignCode) {
      console.log('add to cart');
      const colorsuffix = this.leadProduct.color ? ` (${this.leadProduct.color})` : '';
      const item = {
        prefix: this.leadProduct.title,
        name: `${this.leadProduct.title}${colorsuffix}: ${this.leadDesign.name}`,
        title: `${this.leadProduct.title}${colorsuffix}: ${this.leadDesign.name}`,
        image: this.leadDesign.image.path,
        url: `/ordered/${this.leadDesign.designcode}`,
        designcode: readonlyDesignCode,
        quantity: this.quantity,
        color: this.leadProduct.color,
        sku: this.leadProduct.sku,
        price: this.leadProduct.price,
        weight: this.leadProduct.weightper,
        type: this.leadProduct.id,
        min: this.leadProduct.qtymin,
        max: this.leadProduct.qtymax,
        step: this.leadProduct.qtystep,
      };
      console.log('simpleCart props:', item);

      this.showModal = false;

      if (window.simpleCart) {
        window.simpleCart.add(item);
      } else {
        this.$bvToast.toast(
          'See console.log for cart addition data',
          {
            title: 'No Cart Available',
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: 'danger',
          },
        );
      }
      window.scroll({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#qty {
  display:inline-block;
  width: 5.5rem;
  color: black;
}

.preview {
  text-align: center;
}

.thumb {
  display: inline-block;
  max-width: 100%;
}

.center {
  text-align: center;
}

#review-name label {
  font-size: small;
  position: relative;
  top: -0.35rem;
  padding: 0;
  margin: 0;
  font-weight: bold;
}

#name {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

#review-quantity {
  font-weight: bold;
  font-size: 0.4in;
  position: relative;
  height: 0;
  top: -1.1em;
  left: 1rem;
}

.confirmtext {
  font-size: small;
}

.small {
  font-size: x-small;
}
</style>
